module.exports = __webpack_public_path__ + "img/arrow-down.8c19c083.svg";